import { JsonConverter, JsonCustomConvert } from 'json2typescript';
import { Moment } from 'moment';
import moment from 'moment';

@JsonConverter
export class DateAdapter implements JsonCustomConvert<Moment | undefined> {
    serialize(date: Moment): any | undefined {
        return date ? date.format('YYYY-MM-DD') : '0001-01-01';
    }

    deserialize(date: any): Moment | undefined {
        if (date && ['01/01/0001', '01/01/1900', '0001-01-01', '0002-01-01', '1900-01-01'].indexOf(date) === -1) {
            const withHour = moment(date, 'YYYY-MM-DD HH:mm:ss');
            return withHour.isValid() ? withHour : moment(date, 'YYYY-MM-DD');
        }

        return undefined;
    }
}
